export const crmsTypes = {
  GET_ALL_CRMS_SUCCESS: 'GET_ALL_CRMS_SUCCESS',
  GET_ALL_CRMS_FAILURE: 'GET_ALL_CRMS_FAILURE',
}

export const exportTypes = {
  EXPORT_CSV_SUCCESS: 'EXPORT_CSV_SUCCESS',
  EXPORT_CSV_FAILURE: 'EXPORT_CSV_FAILURE',
}

export const eventosTypes = {
  GET_ALL_EVENTOS_SUCCESS: 'GET_ALL_EVENTOS_SUCCESS',
  GET_ALL_EVENTOS_FAILURE: 'GET_ALL_EVENTOS_FAILURE',
  NEW_EVENTO_SUCCESS: 'NEW_EVENTO_SUCCESS',
  NEW_EVENTO_FAILURE: 'NEW_EVENTO_FAILURE',
  UPDATE_EVENTO_SUCCESS: 'UPDATE_EVENTO_SUCCESS',
  UPDATE_EVENTO_FAILURE: 'UPDATE_EVENTO_FAILURE',
  DELETE_EVENTO_SUCCESS: 'DELETE_EVENTO_SUCCESS',
  DELETE_EVENTO_FAILURE: 'DELETE_EVENTO_FAILURE',
}

export const businessunitsTypes = {
  GET_ALL_BUSINESSUNITS_SUCCESS: 'GET_ALL_BUSINESSUNITS_SUCCESS',
  GET_ALL_BUSINESSUNITS_FAILURE: 'GET_ALL_BUSINESSUNITS_FAILURE',
  NEW_BUSINESSUNIT_SUCCESS: 'NEW_BUSINESSUNIT_SUCCESS',
  NEW_BUSINESSUNIT_FAILURE: 'NEW_BUSINESSUNIT_FAILURE',
  UPDATE_BUSINESSUNIT_SUCCESS: 'UPDATE_BUSINESSUNIT_SUCCESS',
  UPDATE_BUSINESSUNIT_FAILURE: 'UPDATE_BUSINESSUNIT_FAILURE',
  DELETE_BUSINESSUNIT_SUCCESS: 'DELETE_BUSINESSUNIT_SUCCESS',
  DELETE_BUSINESSUNIT_FAILURE: 'DELETE_BUSINESSUNIT_FAILURE',
}

export const userTypes = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGOUT: 'LOGOUT',
  GET_USER_BY_IDUSER_SUCCESS: 'GET_USER_BY_IDUSER_SUCCESS',
  GET_USER_BY_IDUSER_FAILURE: 'GET_USER_BY_IDUSER_FAILURE',
  GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
  GET_ALL_USERS_FAILURE: 'GET_ALL_USERS_FAILURE',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',
  NEW_USER_SUCCESS: 'NEW_USER_SUCCESS',
  NEW_USER_FAILURE: 'NEW_USER_FAILURE',
}

export const rolesTypes = {
  GET_ALL_ROLES_SUCCESS: 'GET_ALL_ROLES_SUCCESS',
  GET_ALL_ROLES_FAILURE: 'GET_ALL_ROLES_FAILURE',
}

export const zonesTypes = {
  GET_ALL_ZONES_SUCCESS: ' GET_ALL_ZONES_SUCCESS',
  GET_ALL_ZONES_FAILURE: 'GET_ALL_ZONES_FAILURE',
}

export const colorsTypes = {
  GET_ALL_COLORS_SUCCESS: ' GET_ALL_COLORS_SUCCESS',
  GET_ALL_COLORS_FAILURE: 'GET_ALL_COLORS_FAILURE',
}

export const positionsTypes = {
  GET_ALL_POSITIONS_SUCCESS: 'GET_ALL_POSITIONS_SUCCESS',
  GET_ALL_POSITIONS_FAILURE: 'GET_ALL_POSITIONS_FAILURE',
  NEW_POSITION_SUCCESS: 'NEW_POSITION_SUCCESS',
  NEW_POSITION_FAILURE: 'UPDATE_POSITION_FAILURE',
  UPDATE_POSITION_SUCCESS: 'UPDATE_POSITON_SUCCESS',
  UPDATE_POSITION_FAILURE: 'UPDATE_POSITION_FAILURE',
  DELETE_POSITION_SUCCESS: 'DELETE_POSITION_SUCCESS',
  DELETE_POSITION_FAILURE: 'DELETE_POSITION_FAILURE',
}

export const departamentsTypes = {
  GET_ALL_DEPARTAMENTS_SUCCESS: 'GET_ALL_DEPARTAMENTS_SUCCESS',
  GET_ALL_DEPARTAMENTS_FAILURE: 'GET_ALL_DEPARTAMENTS_FAILURE',
  NEW_DEPARTAMENT_SUCCESS: 'NEW_DEPARTAMENT_SUCCESS',
  NEW_DEPARTAMENT_FAILURE: 'NEW_DEPARTAMENT_FAILURE',
  UPDATE_DEPARTAMENT_SUCCESS: 'UPDATE_DEPARTAMENT_SUCCESS',
  UPDATE_DEPARTAMENT_FAILURE: 'UPDATE_DEPARTAMENT_FAILURE',
  DELETE_DEPARTAMENT_SUCCESS: 'DELETE_DEPARTAMENT_SUCCESS',
  DELETE_DEPARTAMENT_FAILURE: 'DELETE_DEPARTAMENT_FAILURE',
}

export const specialtiesTypes = {
  GET_ALL_SPECIALTIES_SUCCESS: 'GET_ALL_SPECIALTIES_SUCCESS',
  GET_ALL_SPECIALTIES_FAILURE: 'GET_ALL_SPECIALTIES_FAILURE',
  NEW_SPECIALTY_SUCCESS: 'NEW_SPECIALTY_SUCCESS',
  NEW_SPECIALTY_FAILURE: 'NEW_SPECIALTY_FAILURE',
  UPDATE_SPECIALTY_SUCCESS: 'UPDATE_SPECIALTY_SUCCESS',
  UPDATE_SPECIALTY_FAILURE: 'UPDATE_SPECIALTY_FAILURE',
  DELETE_SPECIALTY_SUCCESS: 'DELETE_SPECIALTY_SUCCESS',
  DELETE_SPECIALTY_FAILURE: 'DELETE_SPECIALTY_FAILURE',
}

export const hospitalsTypes = {
  GET_ALL_HOSPITALS_SUCCESS: 'GET_ALL_HOSPITALS_SUCCESS',
  GET_ALL__HOSPITALS_FAILURE: 'GET_ALL_HOSPITALS_FAILURE',
  GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_SUCCESS:
    'GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_SUCCESS',
  GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_FAILURE:
    'GET_ALL_HOSPITALS_BY_ZONE_CITY_PAGED_FAILURE',
  NEW_HOSPITAL_SUCCESS: 'NEW_HOSPITAL_SUCCESS',
  NEW_HOSPITAL_FAILURE: 'NEW_HOSPITAL_FAILURE',
  UPDATE_HOSPITAL_SUCCESS: 'UPDATE_HOSPITAL_SUCCESS',
  UPDATE_HOSPITAL_FAILURE: 'UPDATE_HOSPITAL_FAILURE',
  DELETE_HOSPITAL_SUCCESS: 'DELETE_HOSPITAL_SUCCESS',
  DELETE_HOSPITAL_FAILURE: 'DELETE_HOSPITAL_FAILURE',
  CLEAR_HOSPITALS_LIST: 'CLEAR_HOSPITALS_LIST',
  GET_ALL_COMMUNITIES_SUCCESS: 'GET_ALL_COMMUNITIES_SUCCESS',
  GET_ALL_COMMUNITIES_FAILURE: 'GET_ALL_COMMUNITIES_FAILURE',
}

export const productsTypes = {
  GET_ARTICLES_BY_FATHER_ID_SUCCESS: 'GET_ARTICLES_BY_FATHER_ID_SUCCESS',
  GET_ARTICLES_BY_FATHER_ID_FAILURE: 'GET_ARTICLES_BY_FATHER_ID_FAILURE',
  GET_ARTICLES_BY_CATEGORY_ID_SUCCESS: 'GET_ARTICLES_BY_CATEGORY_ID_SUCCESS',
  GET_ARTICLES_BY_CATEGORY_ID_FAILURE: 'GET_ARTICLES_BY_CATEGORY_ID_FAILURE',
  GET_ALL_PRODUCTS_SUCCESS: 'GET_ALL_PRODUCTS_SUCCESS',
  GET_ALL_PRODUCTS_FAILURE: 'GET_ALL_PRODUCTS_FAILURE',
  GET_ALL_PRODUCTS_BY_SEARCH_SUCCESS: 'GET_ALL_PRODUCTS_BY_SEARCH_SUCCESS',
  GET_ALL_PRODUCTS_BY_SEARCH_FAILURE: 'GET_ALL_PRODUCTS_BY_SEARCH_FAILURE',
  CLEAR_PRODUCTS_LIST: 'CLEAR_PRODUCTS_LIST',
  UPDATE_PRODUCT_SUCCESS: 'UPDATE_PRODUCT_SUCCESS',
  UPDATE_PRODUCT_FAILURE: 'UPDATE_PRODUCT_FAILURE',
  NEW_PRODUCT_SUCCESS: 'NEW_PRODUCT_SUCCESS',
  NEW_PRODUCT_FAILURE: 'NEW_PRODUCT_FAILURE',
  DELETE_PRODUCT_SUCCESS: 'DELETE_PRODUCT_SUCCESS',
  DELETE_PRODUCT_FAILURE: 'DELETE_PRODUCT_FAILURE',
}

export const familiesTypes = {
  GET_ALL_FAMILIES_SUCCESS: 'GET_ALL_FAMILIES_SUCCESS',
  GET_ALL_FAMILIES_FAILURE: 'GET_ALL_FAMILIES_FAILURE',
  GET_ALL_FAMILIES_BY_SEARCH_SUCCESS: 'GET_ALL_FAMILIES_BY_SEARCH_SUCCESS',
  GET_ALL_FAMILIES_BY_SEARCH_FAILURE: 'GET_ALL_FAMILIES_BY_SEARCH_FAILURE',
  CLEAR_FAMILIES_LIST: 'CLEAR_FAMILIES_LIST',
  UPDATE_FAMILY_SUCCESS: 'UPDATE_FAMILY_SUCCESS',
  UPDATE_FAMILY_FAILURE: 'UPDATE_FAMILY_FAILURE',
  NEW_FAMILY_SUCCESS: 'NEW_FAMILY_SUCCESS',
  NEW_FAMILY_FAILURE: 'NEW_FAMILY_FAILURE',
  DELETE_FAMILY_SUCCESS: 'DELETE_FAMILY_SUCCESS',
  DELETE_FAMILY_FAILURE: 'DELETE_FAMILY_FAILURE',
}

export const tasksTypes = {
  GET_ALL_TASKS_SUCCESS: 'GET_ALL_TASKS_SUCCESS',
  GET_ALL_TASKS_FAILURE: 'GET_ALL_TASKS_FAILURE',
  GET_ALL_TASKS_BY_EVENT_PAGED_SUCCESS: 'GET_ALL_TASKS_BY_EVENT_PAGED_SUCCESS',
  GET_ALL_TASKS_BY_EVENT_PAGED_FAILURE: 'GET_ALL_TASKS_BY_EVENT_PAGED_FAILURE',
  NEW_TASK_SUCCESS: 'NEW_TASK_SUCCESS',
  NEW_TASK_FAILURE: 'NEW_TASK_FAILURE',
  UPDATE_TASK_SUCCESS: 'UPDATE_TASK_SUCCESS',
  UPDATE_TASK_FAILURE: 'UPDATE_TASK_FAILURE',
  DELETE_TASK_SUCCESS: 'DELETE_TASK_SUCCESS',
  DELETE_TASK_FAILURE: 'DELETE_TASK_FAILURE',
  CLEAR_TASKS_LIST: 'CLEAR_TASKS_LIST',
}

export const contactsTypes = {
  GET_ALL_CONTACTS_SUCCESS: 'GET_ALL_CONTACTS_SUCCESS',
  GET_ALL_CONTACTS_FAILURE: 'GET_ALL_CONTACTS_FAILURE',
  UPDATE_CONTACT_SUCCESS: 'UPDATE_CONTACT_SUCCESS',
  UPDATE_CONTACT_FAILURE: 'UPDATE_CONTACT_FAILURE',
  NEW_CONTACT_SUCCESS: 'NEW_CONTACT_SUCCESS',
  NEW_CONTACT_FAILURE: 'NEW_CONTACT_FAILURE',
  DELETE_CONTACT_SUCCESS: 'DELETE_CONTACT_SUCCESS',
  DELETE_CONTACT_FAILURE: 'DELETE_CONTACT_FAILURE',
}

// hospitals_contacts
export const hospitalsContactsTypes = {
  CONTACT_CSV_SUCCESS: 'CONTACT_CSV_SUCCESS',
  CONTACT_CSV_FAILURE: 'CONTACT_CSV_FAILURE',
  GET_ALL_HOSPITALS_CONTACTS_SUCCESS: 'GET_ALL_HOSPITALS_CONTACTS_SUCCESS',
  GET_ALL_HOSPITALS_CONTACTS_FAILURE: 'GET_ALL_HOSPITALS_CONTACTS_FAILURE',
  GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_SUCCESS:
    'GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_SUCCESS',
  GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_FAILURE:
    'GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_FAILURE',
  CLEAR_ALL_HOSPITALS_CONTACTS: 'CLEAR_ALL_HOSPITALS_CONTACTS',
  DELETE_HOSPITALS_CONTACT_SUCCES: 'DELETE_HOSPITALS_CONTACT_SUCCES',
  DELETE_HOSPITALS_CONTACT_FAILURE: 'DELETE_HOSPITALS_CONTACT_FAILURE',
  DELETE_ONE_HOSPITAL_CONTACT_SUCCESS: 'DELETE_ONE_HOSPITAL_CONTACT_SUCCESS',
  DELETE_ONE_HOSPITAL_CONTACT_FAILURE: 'DELETE_ONE_HOSPITAL_CONTACT_FAILURE',
  NEW_HOSPITALS_CONTACT_SUCCESS: 'NEW_HOSPITALS_CONTACT_SUCCESS',
  NEW_HOSPITALS_CONTACT_FAILURE: 'NEW_HOSPITALS_CONTACT_FAILURE',
  UPDATE_HOSPITALS_CONTACT_SUCCESS: 'UPDATE_HOSPITALS_CONTACT_SUCCESS',
  UPDATE_HOSPITALS_CONTACT_FAILURE: 'UPDATE_HOSPITALS_CONTACT_FAILURE',

  GET_HOSPITALS_CONTACT_NOTES_SUCCESS: 'GET_HOSPITALS_CONTACT_NOTES_SUCCESS',
  GET_HOSPITALS_CONTACT_NOTES_FAILURE: 'GET_HOSPITALS_CONTACT_NOTES_FAILURE',
  CREATE_HOSPITALS_CONTACT_NOTE_SUCCESS:
    'CREATE_HOSPITALS_CONTACT_NOTE_SUCCESS',
  CREATE_HOSPITALS_CONTACT_NOTE_FAILURE:
    'CREATE_HOSPITALS_CONTACT_NOTE_FAILURE',
  DELETE_HOSPITALS_CONTACT_NOTE_SUCCESS:
    'DELETE_HOSPITALS_CONTACT_NOTE_SUCCESS',
  DELETE_HOSPITALS_CONTACT_NOTE_FAILURE:
    'DELETE_HOSPITALS_CONTACT_NOTE_FAILURE',
}

// tipo de asuntos
export const eventsTypes = {
  GET_ALL_EVENTS_SUCCESS: 'GET_ALL_EVENTS_SUCCESS',
  GET_ALL_EVENTS_FAILURE: 'GET_ALL_EVENTS_FAILURE',
}

export const phasesTypes = {
  GET_ALL_PHASES_SUCCESS: 'GET_ALL_PHASES_SUCCESS',
  GET_ALL__PHASES_FAILURE: 'GET_ALL_PHASES_FAILURE',
}

export const categoriesTypes = {
  GET_ALL_CATEGORIES_SUCCESS: 'GET_ALL_CATEGORIES_SUCCESS',
  GET_ALL__CATEGORIES_FAILURE: 'GET_ALL_CATEGORIES_FAILURE',
  UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
  UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',
  NEW_CATEGORY_SUCCESS: 'NEW_CATEGORY_SUCCESS',
  NEW_CATEGORY_FAILURE: 'NEW_CATEGORY_FAILURE',
  DELETE_CATEGORY_SUCCESS: 'DELETE_CATEGORY_SUCCESS',
  DELETE_CATEGORY_FAILURE: 'DELETE_CATEGORY_FAILURE',
}

// tipos de documentos de los pdfs
export const documentsTypes = {
  GET_ALL_TYPE_OF_DOCUMENTS_SUCCESS: 'GET_ALL_TYPE_OF_DOCUMENTS_SUCCESS',
  GET_ALL__TYPE_OF_DOCUMENTS_FAILURE: 'GET_ALL_TYPE_OF_DOCUMENTS_FAILURE',
}

// presentaciones
export const presentationsTypes = {
  GET_ALL_PRESENTATIONS_SUCCESS: 'GET_ALL_PRESENTATIONS_SUCCESS',
  GET_ALL_PRESENTATIONS_FAILURE: 'GET_ALL_PRESENTATIONS_FAILURE',
  GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_SUCCESS:
    'GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_SUCCESS',
  GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_FAILURE:
    'GET_ALL_PRESENTATIONS_BY_TITLE_PAGED_FAILURE',
  CLEAR_PRESENTATIONS_LIST: 'CLEAR_PRESENTATIONS_LIST',
  NEW_PRESENTATIONS_CONTACT_HOSPITAL_SUCCESS:
    'NEW_PRESENTATIONS_CONTACT_HOSPITAL_SUCCESS',
  NEW_PRESENTATIONS_CONTACT_HOSPITAL_FAILURE:
    'NEW_PRESENTATIONS_CONTACT_HOSPITAL_FAILURE',
  DELETE_PRESENTATIONS_SUCCESS: 'DELETE_PRESENTATIONS_SUCCESS',
  DELETE_PRESENTATIONS_FAILURE: 'DELETE_PRESENTATIONS_FAILURE',
  UPDATE_PRESENTATIONS_SUCCESS: 'UPDATE_PRESENTATIONS_SUCCESS',
  UPDATE_PRESENTATIONS_FAILURE: 'UPDATE_PRESENTATIONS_FAILURE',
  GET_PRESENTATION_BY_ID_SUCCESS: 'GET_PRESENTATION_BY_ID_SUCCESS',
  GET_PRESENTATION_BY_ID_FAILURE: 'GET_PRESENTATION_BY_ID_FAILURE',
}

export const timeSlotsTypes = {
  GET_ALL_TIMESLOTS_SUCCESS: 'GET_ALL_TIMESLOTS_SUCCESS',
  GET_ALL_TIMESLOTS_FAILURE: 'GET_ALL_TIMESLOTS_FAILURE',
}

// Presentacion vista por un contacto
export const infoProfileContactHospitalPresentationTypes = {
  GET_INFO_CONTACT_HOSPITAL_PRESENTATION_SUCCESS:
    'GET_INFO_CONTACT_HOSPITAL_PRESENTATION_SUCCESS',
  GET_INFO_CONTACT_HOSPITAL_PRESENTATION_FAILURE:
    'GET_INFO_CONTACT_HOSPITAL_PRESENTATION_FAILURE',
}

export const getProductsContactPresentationTypes = {
  GET_PRODUCTS_CONTACT_PRESENTATION_SUCCESS:
    'GET_PRODUCTS_CONTACT_PRESENTATION_SUCCESS',
  GET_PRODUCTS_CONTACT_PRESENTATION_FAILURE:
    'GET_PRODUCTS_CONTACT_PRESENTATION_FAILURE',
}

export const lgpdPolicyTypes = {
  MARK_AS_READ_LGPD_POLICY_SUCCESS: 'MARK_AS_READ_LGPD_POLICY_SUCCESS',
  MARK_AS_READ_LGPD_POLICY_FAILURE: 'MARK_AS_READ_LGPD_POLICY_FAILURE',
  ACCEPT_LGPD_POLICY_SUCCESS: 'ACCEPT_LGPD_POLICY_SUCCESS',
  ACCEPT_LGPD_POLICY_FAILURE: 'ACCEPT_LGPD_POLICY_FAILURE',
  REJECT_LGPD_POLICY_SUCCESS: 'REJECT_LGPD_POLICY_SUCCESS',
  REJECT_LGPD_POLICY_FAILURE: 'REJECT_LGPD_POLICY_FAILURE',
}
